// Types
import type { TAnchorAs, TAnchorProps, TAnchorSize } from './Anchor.type';

export const ANCHOR_TAGS: TAnchorAs[] = [ 'a', 'span' ];
export const ANCHOR_TAG: { [key in TAnchorAs ]: key } = {
  a: 'a',
  span: 'span'
}

export const ANCHOR_SIZES: TAnchorSize[] = [ 'sm', 'md', 'lg' ];
export const ANCHOR_SIZE:  { [key in TAnchorSize ]: key } = {
  sm: 'sm',
  md: 'md',
  lg: 'lg'
}

export const ANCHOR_DEFAULT_PROPS: TAnchorProps = {
  as: ANCHOR_TAG.a,
  size: ANCHOR_SIZE.md,
}
